module.exports = __webpack_public_path__ + "img/newt1.4d2e332a.png";